import React from "react";
import styled from "styled-components";

const VerticalBox = styled.div`
  width: 2.8rem;

  & > div {
    width: 2.1rem;
    cursor: move;
    background-image: url("/move-handle-v.png");
    background-size: 11px 24px;
    background-repeat: no-repeat;
    background-position: center 3px;
    opacity: 0.5;
    min-height: 30px;
  }
  & > div:hover {
    background-color: #e7e7e7;
    opacity: 1;
  }
`;

const HorizontalBox = styled.div`
  width: 2.8rem;

  & > div {
    width: 2.1rem;
    cursor: move;
    background-image: url("/move-handle-v.png");
    background-size: 11px 24px;
    background-repeat: no-repeat;
    background-position: center 3px;
    opacity: 0.5;
    min-height: 30px;
  }
  & > div:hover {
    background-color: #e7e7e7;
    opacity: 1;
  }
`;

interface Props {
  direction: "horizontal" | "vertical";
}

const DragHandle: React.FC<React.PropsWithChildren<Props>> = (props) => {
  switch (props.direction) {
    case "horizontal":
      return (
        <HorizontalBox>
          <div></div>
        </HorizontalBox>
      );
    case "vertical":
      return (
        <VerticalBox>
          <div></div>
        </VerticalBox>
      );
  }
};

export default DragHandle;
